const makeKey = (name: string) => name && name
	.normalize('NFD') // separate diacritics
	.replace(/[\u0300-\u036f]/g, '') // remove diacritics
	.toLowerCase() // well...
	.replace(/[^a-z0-9]/g, '-') // replace non alphanumerics
	.replace(/^-*|-*$/g, '') // remove leading and trailing dashes (could cause collisions, mostly just fixes erroneous spaces and quotes)

export default makeKey
